import { all, takeEvery, call, put } from "redux-saga/effects";
// import { push } from "react-router-redux";
import * as actionTypes from "../constants/actionTypes";
import * as actions from "../actions";
import axios from "../services";
import { toast } from "react-toastify";
import { sessionExpiredMsg } from "../constants/constants";

function* signIn(action) {
  try {
    const { phone, password, countryCode } = action.payload;
    let countrycode = countryCode.code;
    let response = yield axios
      .post("/users/login", {
        phone,
        password,
        fcmToken: localStorage.getItem('gtoken') != null ? localStorage.getItem('gtoken') : 'web',
        // countryCode: encodeURIComponent(countryCode)
        countryCode
      })
      .then(async response => response)
      .catch(async error => {
        return error;
      });
    if (response.status == 200) {
      yield localStorage.setItem(
        "userData",
        JSON.stringify(response.data.data)
      );
      if (response.data.data.isVerify == false) {
        yield localStorage.setItem(
          "userData",
          JSON.stringify(response.data.data)
        );
        yield put(actions.changeRedirectURL('/phone-verification'));
        yield put(actions.hideAppLoader());
      } else if (response.data.data.email == '' || response.data.data.email == undefined) {
        sessionStorage.setItem('signupprofile', true);
        yield put(actions.changeRedirectURL('/signup-profile'));
      } else {
        yield put(actions.signInRequestSuccess(response.data.data));
      }
      yield localStorage.setItem("token", response.data.data.token);
      yield put(actions.hideAppLoader());
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));

    }
  } catch (error) {

  }
}

function* logOut(action) {
  let gtoken = localStorage.getItem("gtoken");
  try {
    let response = yield axios
      .put("/users/logout", {})
      .then(async response => response)
      .catch(async error => {
        await put(actions.resetApp());
        await put(actions.logOutRequestSuccess());
        await put(actions.hideAppLoader());
        await put(actions.modalClose());
        localStorage.clear();
        if (gtoken != null) {
          localStorage.setItem("gtoken", gtoken);
        }
      });
    if (response.status == 200) {
      yield put(actions.resetApp());
      yield put(actions.logOutRequestSuccess());
      yield put(actions.hideAppLoader());
      yield put(actions.modalClose());
      yield put(actions.conformationModalClose());
      localStorage.clear();
      if (gtoken != null) {
        localStorage.setItem("gtoken", gtoken);
      }
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else {
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.resetApp());
      yield put(actions.logOutRequestSuccess());
      yield put(actions.hideAppLoader());
      localStorage.clear();
      if (gtoken != null) {
        localStorage.setItem("gtoken", gtoken);
      }
    }
  } catch (error) {
    yield put(actions.resetApp());
    yield put(actions.logOutRequestSuccess());
    yield put(actions.hideAppLoader());
    localStorage.clear();
    if (gtoken != null) {
      localStorage.setItem("gtoken", gtoken);
    }
  }
}
function* signUp(action) {
  try {
    const { phone, password, countryCode, referenceCode, alpha3Code } = action.payload;
    let response = yield axios
      .post("/users/register", {
        phone,
        password,
        referenceCode,
        countryCode,
        countryAlpha3Code: alpha3Code,
        deviceType: "web",
        fcmToken: localStorage.getItem('gtoken') != null ? localStorage.getItem('gtoken') : 'web',
      })
      .then(async response => response)
      .catch(async error => {
        return error;
      });
    if (response.status == 200) {
      yield localStorage.setItem(
        "userData",
        JSON.stringify(response.data.data)
      );
      yield localStorage.setItem("token", response.data.data.token);
      yield put(actions.signUpRequestSuccess(response.data));
      yield put(actions.hideAppLoader());
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
  }
}

function* forgotPassword(action) {
  try {
    const { phone, countryCode } = action.payload;
    let response = yield axios
      .post("/users/forgot-password", {
        phone,
        countryCode
      })
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      yield put(actions.hideAppLoader());
      localStorage.setItem('forgotData', JSON.stringify(response.data.data))
      yield localStorage.setItem("token", response.data.data.token);
      yield put(actions.forgotPasswordRequestSuccess({ forgotPasswordState: true, userId: response.data.data._id }));
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
  }
}

function* changePassword(action) {
  try {
    const { userId, code, newPassword } = action.payload;
    let response = yield axios
      .post("/users/change-password", {
        userId,
        code,
        newPassword
      })
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      yield put(actions.hideAppLoader());
      yield put(actions.changeRedirectURL('/password-changed-successfully'));
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
  }
}

function* phoneVerification(action) {
  try {
    const { otp, userId } = action.payload;
    // let response = yield axios.get(`/users/verify-otp?otp=${otp}&userId=${userId}`)
    let response = yield axios.post(`/users/verify-otp`, {
      otp,
      userId
    })
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      yield put(actions.hideAppLoader());
      yield put(actions.phoneVerificationRequestSuccess(true));
      yield localStorage.setItem(
        "userData",
        JSON.stringify(response.data.data)
      );
      yield localStorage.setItem("token", response.data.data.token);
      sessionStorage.setItem('signupprofile', true);
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
  }
}

function* resendOTP(action) {
  try {
    const { phone, countryCode } = action.payload;
    // let response = yield axios.get(`/users/resend-otp?phone=${phone}&countryCode=${countryCode.replace('+', '%2B')}`)
    let response = yield axios.post(`/users/resend-otp`, {
      phone: phone,
      countryCode: countryCode
    })
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.data.data, notifyType: 2 }));
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    }else {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  }catch (error) {
  yield put(actions.hideAppLoader());
}
}

function* signUpProfile(action) {
  try {
    let response = yield axios
      .put(`/users`, action.payload)
      .then(async response => response)
      .catch(async error => {
        return error;
      });

    if (response.status == 200) {
      yield localStorage.setItem("userData", JSON.stringify(response.data.data));
      if (action.payload.actionName == 'edituser') {
        yield put(actions.getUserSuccess(response.data.data));
        yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2, redirectURL: `/profile` }));
      }
      yield put(actions.hideAppLoader());
    } else if (response == "Error: Request failed with status code 401") {
      yield put(actions.hideAppLoader());
      yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else {
      yield put(actions.hideAppLoader());
      yield localStorage.setItem("token", response.data.data.token);
      yield put(actions.SignUpProfileSuccess(response.data));
      yield put(actions.modalOpen({ message: response.message }));
      yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
  } catch (error) {
    yield put(actions.hideAppLoader());
  }
}

export default function* rootsaga() {
  yield takeEvery(actionTypes.SIGNIN_REQUEST, signIn);
  yield takeEvery(actionTypes.LOGOUT_REQUEST, logOut);
  yield takeEvery(actionTypes.SIGNUP_REQUEST, signUp);
  yield takeEvery(actionTypes.FORGOT_PASSWORD_REQUEST, forgotPassword);
  yield takeEvery(actionTypes.CHANGE_PASSWORD, changePassword);
  yield takeEvery(actionTypes.PHONE_VERIFICATION_REQUEST, phoneVerification);
  yield takeEvery(actionTypes.PHONE_VERIFICATION_RESEND_REQUEST, resendOTP);
  yield takeEvery(actionTypes.SIGNUP_PROFILE, signUpProfile);
}
